module.exports = __webpack_public_path__ + "img/new_point0x.6cbcc215.png";